import React, { Component } from 'react'

import moment from 'moment'
import PropTypes from 'prop-types'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import Loader from '../../common/Loader'
import { withRouter } from 'react-router-dom'
import { filterCaseInsensitive, getModalId } from '../../../util'
import history from '../../../history'
import { Form, message, Tooltip } from 'antd'

import * as stopCallSelectors from '../../../selectors/job/stopCall'
import { actions as jobStopCallActions } from '../../../redux/modules/jobFunctions/jobStopCallActions'

import AddEditModal from '../../../components/jobs/stop_call/AddEditModal'

const propTypes = {
  // actions
  jobStopCallsRefresh: PropTypes.func.isRequired,
  createStopCall: PropTypes.func.isRequired,
  updateStopCall: PropTypes.func.isRequired,
  deleteStopCall: PropTypes.func.isRequired,
  fetchStopCallAttachments: PropTypes.func.isRequired
}

class StopCalls extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: getModalId(props.location.pathname),
      selectedStopCall: null,
      isModalOpen: false
    }
  }

  componentWillMount() {
    const { jobStopCallsRefresh } = this.props
    jobStopCallsRefresh({
      jobId: this.props.jobId,
      callback: payload => {
        if (this.shouldRenderModal()) {
          const selectedStopCall =
            payload.data && payload.data.find(d => String(d.id) === String(this.state.currentId))
          this.handleRowClick(selectedStopCall)
        }
      }
    })
  }

  shouldRenderModal = () => {
    return /modal\/\d+$/.test(window.location.href)
  }

  redirectToStopCalls = () => {
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/stop-calls`)
    this.forceUpdate()
  }

  handleRowClick = row => {
    const { fetchStopCallAttachments } = this.props
    fetchStopCallAttachments(row.id)
    this.setState({
      isModalOpen: true,
      currentId: row.id,
      selectedStopCall: row
    })
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/stop-calls/modal/${row.id}`)
    this.forceUpdate()
  }

  handleAddButton = () => {
    this.setState({
      currentId: 0,
      selectedStopCall: null
    })
    const { jobType, jobId } = this.props.match.params
    history.push(`/jobView/${jobId}/${jobType}/stop-calls/modal/0`)
    this.forceUpdate()
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, isModalOpen: false }, this.redirectToStopCalls)
  }

  createStopCall = values => {
    const { createStopCall } = this.props
    createStopCall({
      jobId: this.props.jobId,
      content: values
    })

    this.setState(
      { selectedStopCall: null, currentId: 0, isModalOpen: false },
      this.redirectToStopCalls
    )
  }

  updateStopCall = values => {
    const { updateStopCall } = this.props

    updateStopCall({
      jobId: this.props.jobId,
      stopCallId: this.state.currentId,
      content: values
    })

    this.setState(
      { selectedStopCall: null, currentId: 0, isModalOpen: false },
      this.redirectToStopCalls
    )
  }

  handleDeleteStopCall = stopCallId => {
    const { deleteStopCall } = this.props
    const form = this.props.form

    deleteStopCall({
      jobId: this.props.jobId,
      stopCallId: stopCallId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState(
      {
        selectedStopCall: null,
        currentId: 0,
        isModalOpen: false
      },
      this.redirectToStopCalls
    )
  }

  render() {
    const { stopCallItems } = this.props
    const { selectedStopCall } = this.state

    if (!stopCallItems) {
      return <Loader />
    }
    return (
      <div>
        {this.shouldRenderModal() && (
          <AddEditModal
            selectedStopCall={selectedStopCall}
            isModalOpen={true}
            handleCancel={this.handleCancel}
            createStopCall={this.createStopCall}
            updateStopCall={this.updateStopCall}
            deleteStopCall={this.handleDeleteStopCall}
          />
        )}
        <div className="jobsBar">
          Stop Calls
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Stop Call
            </div>
          </div>
        </div>
        {stopCallItems && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTrProps={(state, rowInfo, column, instance) => ({
              onClick: e => this.handleRowClick(rowInfo.original)
            })}
            data={stopCallItems}
            columns={[
              {
                columns: [
                  {
                    Header: 'Number',
                    accessor: 'number',
                    maxWidth: 80
                  },
                  {
                    Header: 'Stop Call Date',
                    id: 'stop_call_date',
                    accessor: d => moment(d.stop_call_date).format('M/D/YYYY'),
                    sortMethod: (a, b) => Date.parse(a) - Date.parse(b)
                  },
                  {
                    Header: 'Caller Name',
                    id: 'caller_name',
                    accessor: 'caller_name',
                    Cell: d => (
                      <Tooltip title={d.original.caller_name}>{d.original.caller_name}</Tooltip>
                    )
                  },
                  {
                    Header: 'Complaint',
                    id: 'complaint',
                    accessor: 'complaint',
                    Cell: d => (
                      <Tooltip title={d.original.complaint}>{d.original.complaint}</Tooltip>
                    )
                  },
                  {
                    Header: 'Mechanic',
                    id: 'mechanic',
                    accessor: 'mechanic',
                    Cell: d => <Tooltip title={d.original.mechanic}>{d.original.mechanic}</Tooltip>
                  },
                  {
                    Header: 'Status',
                    accessor: 'status',
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === 'completed' ? '#ff0000' : '#57d500',
                            transition: 'all .3s ease'
                          }}
                        >
                          &#x25cf;
                        </span>
                        &nbsp;{row.value === 'completed' ? 'Completed' : 'Open'}
                      </span>
                    ),
                    filterMethod: (filter, row) => {
                      if (filter.value === 'all') return true
                      return filter.value === row.status
                    },
                    Filter: ({ filter, onChange }) => (
                      <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : 'all'}
                      >
                        <option value="all">All</option>
                        <option value="open">Open</option>
                        <option value="completed">Completed</option>
                      </select>
                    ),
                    minWidth: 60
                  },
                  {
                    Header: 'Billable',
                    accessor: 'billable',
                    Cell: row => (
                      <span>
                        <span
                          style={{
                            color: row.value === 0 ? '#ff0000' : '#57d500',
                            transition: 'all .3s ease'
                          }}
                        >
                          &#x25cf;
                        </span>
                        &nbsp;{row.value === 1 ? 'Yes' : 'No'}
                      </span>
                    ),
                    filterMethod: (filter, row) => {
                      if (filter.value === 'all') return true
                      return parseInt(filter.value, 10) === row.billable
                    },
                    Filter: ({ filter, onChange }) => (
                      <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: '100%' }}
                        value={filter ? filter.value : 'all'}
                      >
                        <option value="all">All</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                      </select>
                    ),
                    minWidth: 60
                  },
                  {
                    Header: 'Created date',
                    id: 'created_date',
                    accessor: 'created_date',
                    Cell: d => {
                      const r = moment.utc(d.original.created_date).format('M/D/YYYY')
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Created by',
                    id: 'created_date',
                    accessor: 'created_by',
                    Cell: d => {
                      const r = `${d.original.created_by_first_name} 
                                  ${d.original.created_by_last_name}`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated Date',
                    id: 'updated_date',
                    accessor: 'updated_date',
                    minWidth: 60,
                    Cell: d => {
                      const r = moment.utc(d.original.updated_date).format('M/D/YYYY')
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated by',
                    id: 'updated_date',
                    accessor: 'updated_by',
                    Cell: d => {
                      const r = `${d.original.updated_by_first_name} 
                                  ${d.original.updated_by_last_name}`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  stopCallItems: stopCallSelectors.getStopCallItems(state, props)
})
const mapDispatchToProps = (dispatch, props) => ({
  jobStopCallsRefresh: ({ jobId, callback }) =>
    dispatch(jobStopCallActions.jobStopCallsRefresh({ jobId, callback })),
  createStopCall: ({ jobId, content }) =>
    dispatch(jobStopCallActions.createStopCall({ jobId, content })),
  updateStopCall: ({ jobId, stopCallId, content }) =>
    dispatch(jobStopCallActions.updateStopCall({ jobId, stopCallId, content })),
  deleteStopCall: ({ stopCallId, jobId }) =>
    dispatch(jobStopCallActions.deleteStopCall({ stopCallId, jobId })),
  fetchStopCallAttachments: stopCallId =>
    dispatch(jobStopCallActions.fetchStopCallAttachments(stopCallId))
})

StopCalls.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(StopCalls)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobStopCalls.js